export const moderateUserName = (axiosInstance, data) => {
  return axiosInstance.post('/mod/n', data);
};

export const moderateContent = (axiosInstance, data) => {
  return axiosInstance.post(`/mod/c`, data);
};
